import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const PDF_URL = (kind, id, lang) =>
  `${API}/${kind === "quote" ? "quotes" : "invoices"}/${id}/pdf?lang=${lang}`;

// Customers
export const getCustomers = () => api.get("/customers").then((r) => r.data);
export const createCustomer = (d) => api.post("/customers", d).then((r) => r.data);
export const updateCustomer = (id, d) => api.put(`/customers/${id}`, d).then((r) => r.data);
export const deleteCustomer = (id) => api.delete(`/customers/${id}`).then((r) => r.data);

// Products
export const getProducts = () => api.get("/products").then((r) => r.data);
export const createProduct = (d) => api.post("/products", d).then((r) => r.data);
export const updateProduct = (id, d) => api.put(`/products/${id}`, d).then((r) => r.data);
export const deleteProduct = (id) => api.delete(`/products/${id}`).then((r) => r.data);

// Quotes
export const getQuotes = () => api.get("/quotes").then((r) => r.data);
export const getQuote = (id) => api.get(`/quotes/${id}`).then((r) => r.data);
export const createQuote = (d) => api.post("/quotes", d).then((r) => r.data);
export const updateQuote = (id, d) => api.put(`/quotes/${id}`, d).then((r) => r.data);
export const setQuoteStatus = (id, status) => api.patch(`/quotes/${id}/status`, { status }).then((r) => r.data);
export const deleteQuote = (id) => api.delete(`/quotes/${id}`).then((r) => r.data);
export const convertQuote = (id) => api.post(`/quotes/${id}/convert`).then((r) => r.data);

// Invoices
export const getInvoices = () => api.get("/invoices").then((r) => r.data);
export const getInvoice = (id) => api.get(`/invoices/${id}`).then((r) => r.data);
export const createInvoice = (d) => api.post("/invoices", d).then((r) => r.data);
export const updateInvoice = (id, d) => api.put(`/invoices/${id}`, d).then((r) => r.data);
export const setInvoiceStatus = (id, status) => api.patch(`/invoices/${id}/status`, { status }).then((r) => r.data);
export const deleteInvoice = (id) => api.delete(`/invoices/${id}`).then((r) => r.data);

// Settings & dashboard
export const getSettings = () => api.get("/settings").then((r) => r.data);
export const updateSettings = (d) => api.put("/settings", d).then((r) => r.data);
export const getDashboard = () => api.get("/dashboard").then((r) => r.data);

// Payments
export const createCheckout = (invoice_id) =>
  api.post("/payments/checkout", { invoice_id, origin_url: window.location.origin }).then((r) => r.data);
export const getPaymentStatus = (sid) => api.get(`/payments/status/${sid}`).then((r) => r.data);

export default api;
